module.exports = __webpack_public_path__ + "static/media/hot_ayzc.20135bad.png";